import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";
import {
  Alert,
  AlertDescription,
  Link,
  ServiceIconShell,
  Text,
} from "@zapier/design-system";
import { getBuildAssetUrl, getAssetIcon, AssetTypes } from "@zapier/utils";
import styles from "./LinkedAssetsWarning.module.css";

export interface LinkedAsset {
  id: string | number;
  title?: string | null;
  type: AssetTypes;
}

interface LinkedAssetsWarningProps {
  linkedAssets: LinkedAsset[];
}

export const LinkedAssetsList = ({
  linkedAssets,
}: LinkedAssetsWarningProps) => {
  return (
    <ul className={styles.linkedAssetList}>
      {linkedAssets.map((asset) => {
        const assetUrl = getBuildAssetUrl(asset.type, asset.id);
        const assetTitle = asset.title || "";

        return (
          <li key={asset.id} className={styles.linkedAssetItem}>
            <ServiceIconShell size="small">
              <Icon
                color="BrandOrange"
                name={getAssetIcon(asset.type)}
                size={12}
              />
            </ServiceIconShell>
            {assetUrl ? (
              <Link href={assetUrl}>{assetTitle}</Link>
            ) : (
              <Text>{assetTitle}</Text>
            )}
          </li>
        );
      })}
    </ul>
  );
};

const LinkedAssetsWarning = ({ linkedAssets }: LinkedAssetsWarningProps) => {
  const t = useTranslations("linked-assets-warning");

  return (
    <div className={styles.warningContainer}>
      <Alert status="warning">
        <AlertDescription>
          {t("warnings.ownership-change-limitation")}
        </AlertDescription>
      </Alert>

      <Text color="TextWeaker" tag="p">
        {t("descriptions.assets-not-changing-ownership")}
      </Text>
      <LinkedAssetsList linkedAssets={linkedAssets} />
    </div>
  );
};

export default LinkedAssetsWarning;
